import React from 'react';
import LaunchIcon from '@mui/icons-material/Launch';
import { useTranslation } from 'react-i18next';
import { t } from 'i18next';
import { EventItem } from 'queries/events/types';
import { EVENT_PAGE } from 'config/paths';
import './style.scss';
import { SeverityPills } from '@shape/lighthouse-components';
import { severityMap } from 'components/SeverityPanel';
import { IconButton } from '@mui/material';
import { EllipsisTextWithTooltip } from '@shape-ds/components';

interface EventTitleProps {
  event: EventItem;
  showExpandButton?: boolean;
}
const getTagLabel = (event: EventItem) => {
  if (event.isChild) {
    return `${t('event_page:tag.aggregated')}`;
  }
  return `${event?.children?.length} ${t('event_page:tag.alarms')} `;
};
const EventTitle: React.FC<EventTitleProps> = ({ event, showExpandButton }) => {
  const { t } = useTranslation();
  const title = `${t('event_page:alarm')} ${event.description}`;

  return (
    <div className="event-header">
      <SeverityPills severity={severityMap[event.severity]} totalPills={4} />

      <EllipsisTextWithTooltip text={title} className="event-header-title" />

      {event.children && event.children.length > 0 ? (
        <span className="event-tag">{getTagLabel(event)}</span>
      ) : (
        <span />
      )}

      {showExpandButton && (
        <IconButton
          className="launch-icon"
          onClick={() => window.open(EVENT_PAGE(event.id), '_blank')}
        >
          <LaunchIcon fontSize="small" />
        </IconButton>
      )}
    </div>
  );
};

export default EventTitle;
